var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00FFDA",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0c26.51 0 48 21.49 48 48S74.51 96 48 96 0 74.51 0 48 21.49 0 48 0zm0 6C24.804 6 6 24.804 6 48s18.804 42 42 42 42-18.804 42-42S71.196 6 48 6z",
    fillOpacity: 0.103,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.36 55.298 19.62-20.575a2.279 2.279 0 0 1 3.33 0c.92.963.92 2.527 0 3.49L44.062 61.542a1.445 1.445 0 0 1-2.113 0L29.69 48.686a2.554 2.554 0 0 1 0-3.49 2.278 2.278 0 0 1 3.33 0l9.634 10.102a.484.484 0 0 0 .706 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.96fd5be12f69c130e7e8b9735dd2645d.svg";
export { ForwardRef as ReactComponent };